const LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY = "shopify-recent-view",
    LOCAL_STORAGE_DELIMITER = ",",
    MAX_RECENT_VIEWED_PRODUCTS = 5;

function initRecentlyViewedSection(container) {
    const recentViewdProduct = container.querySelector(".recently_viewed-proudct");
    if (!recentViewdProduct) return;

    const recentViewedProductHandle = recentViewdProduct.dataset.productHandle;
    const Recentgrid = container.querySelector("[grid-recentViewProduct]");

    if (!recentViewedProductHandle) {
        console.error("[recentViewProduct] Missing `data-product-handle`.");
        return;
    }

    updateRecentViewProduct(recentViewedProductHandle);
    if (Recentgrid) {
        setupRecentViewGrid(Recentgrid, recentViewdProduct, recentViewedProductHandle);
    }
}

function setupRecentViewGrid(Recentgrid, recentViewdProduct, recentViewedProductHandle) {
    const recentProducts = getRecentViewProduct();

    if (recentProducts.length > 1) {
        recentViewdProduct.classList.remove("no-js-inline");
    }

    const requests = recentProducts
        .slice(-MAX_RECENT_VIEWED_PRODUCTS)
        .reverse()
        .map(function (handle) {
            if (handle !== recentViewedProductHandle) {
                return fetch(`/products/${handle}?view=card`).then(res => res.text());
            }
        });

    Promise.all(requests).then(function (responses) {
        const validResponses = responses.filter(Boolean).join("");
        Recentgrid.innerHTML = validResponses;
    });
}

function getRecentViewProduct() {
    const stored = localStorage.getItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY);
    return stored ? stored.split(LOCAL_STORAGE_DELIMITER) : [];
}

function setRecentViewProduct(array) {
    const trimmed = array.slice(-MAX_RECENT_VIEWED_PRODUCTS);
    const stored = trimmed.join(LOCAL_STORAGE_DELIMITER);
    if (trimmed.length) {
        localStorage.setItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY, stored);
    }
    return stored;
}

function updateRecentViewProduct(handle) {
    let recent = getRecentViewProduct();
    const index = recent.indexOf(handle);

    if (index !== -1) {
        recent.splice(index, 1); // remove existing
    }

    recent.push(handle); // add to end
    return setRecentViewProduct(recent);
}

// Optional helper functions if needed
function recentViewProductContains(handle) {
    return getRecentViewProduct().indexOf(handle) !== -1;
}

function resetRecentViewProduct() {
    return setRecentViewProduct([]);
}

// Load on initial page load
document.addEventListener("DOMContentLoaded", function () {
    initRecentlyViewedSection(document);
});

// Re-run when section is dynamically reloaded in Shopify customizer
document.addEventListener("shopify:section:load", function (event) {
    initRecentlyViewedSection(event.target);
});
